import React, {useEffect, useState} from 'react';
import {Form, Header, Message, Segment, Table} from 'semantic-ui-react';
import {useLoaderData, useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import {useBlockUI} from 'shared/services/block-ui-service';
import {ToasterConfig} from "../../../../config/ToasterConfig";
import useBusinessUnitService from "../../../../services/backoffice/hooks/useBusinessUnitService";
import {EditBusinessUnitRequest} from "../../../../models/requests/edit-business-unit-request";
import useClientService from "../../../../services/backoffice/hooks/useClientService";
import {ShortDto} from "../../../../models/short-dto";

export async function editBusinessUnitLoader({params}: any) {
    return params.id;
}

const EditBusinessUnitPage = () => {
    const [businessUnit, setBusinessUnit] = useState<Partial<EditBusinessUnitRequest>>();
    const [loading, setLoading] = useState<boolean>(false);
    const [clientes, setClients] = useState<ShortDto[]>([])
    const [error, setError] = useState<string>('');
    const navigate = useNavigate();
    const loader: any = useLoaderData();
    const blockUI = useBlockUI();
    const {editBusinessUnit, getBusinessUnitById} = useBusinessUnitService();
    const {getAllClientsShortDto} = useClientService();
    useEffect(() => {
        blockUI?.setActive(loading)
    }, [loading]);

    useEffect(() => {
        const businessUnitId = loader;
        if (!businessUnitId) return;
        getBusinessUnitById(businessUnitId).then((response: any) => {
            setBusinessUnit(response)
        })
    }, [loader])


    useEffect(() => {
        function ListClientes() {
            getAllClientsShortDto().then((response) => {
                setClients(response);
            })
                .catch(error => {
                })
        }

        ListClientes()
    }, [])


    const handleClienteIdChange = (e: any, data: any) => {
        const selectedValue = data.value;
        setBusinessUnit(prevBusinessUnit => ({...prevBusinessUnit, clientId: selectedValue}));
    };

    const updateBusinessUnitt = async () => {
        try {
            setLoading(true);
            if (businessUnit) {
                const result = await editBusinessUnit(businessUnit, businessUnit.id)
                    .finally(() => setLoading(false));
                if (!!result) navigate('/backoffice/business-units/')
                toast.success('Unidade de negócio atualizada com sucesso', ToasterConfig.success);
            }
        } catch (error: any) {
            setLoading(false);
            setError(error.message);
        }
    };

    return (
        <div>
            <Header as="h3" textAlign="center" color={'green'}>
                Unidades de negócio / Editar
            </Header>
            <Form size="large" onSubmit={updateBusinessUnitt}>
                <Segment stacked>


                    <Form.Input
                        fluid
                        label="Nome"
                        placeholder="Nome"
                        name="name"
                        value={businessUnit?.name}
                        onChange={(event) => setBusinessUnit({...businessUnit, name: event.target.value})}
                        required
                    />

                    <Form.Input
                        fluid
                        label="Descrição"
                        placeholder="Descrição"
                        name="description"
                        value={businessUnit?.description}
                        onChange={(event) => setBusinessUnit({...businessUnit, description: event.target.value})}
                        required
                    />


                    <Form.Select
                        label={'Cliente ao qual a Unidade de Negócio pertence'}
                        options={clientes}
                        placeholder='Selecione uma opção'
                        value={businessUnit?.clientId || ''}
                        required
                        onChange={handleClienteIdChange}
                    />


                    <Table.Row>
                        <Table.HeaderCell>
                            <Form.Button content="Voltar"
                                         icon='arrow left'
                                         onClick={() => navigate('/backoffice/business-units/')} grey/>
                        </Table.HeaderCell>
                        <Table.HeaderCell>
                            <Form.Button content="Atualizar"
                                         type={"submit"}
                                         icon='save'
                                         color={"green"}/>
                        </Table.HeaderCell>
                    </Table.Row>
                    {error && <Message negative>{error}</Message>}
                </Segment>
            </Form>
        </div>
    );
};

export default EditBusinessUnitPage;
